export default "__VITE_ASSET__1ff8dd88__"